import React, { useState, useEffect } from 'react';
import { object, func, bool, string } from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { MESSAGE_MODALS } from '../../../context/custom/MessageModalContext';
import { ALERT_TYPE, ShowToastMessage, sequenceActionNext } from '@laramie/ui';
import { TableCustom } from '../../common';
import { getDateToString } from '../../../utils/convert';
import { useLista } from '../../hooks/useLista';
import HabilitacionComercioModal from '../HabilitacionComercioModal';
import { isNull } from '../../../utils/validator';
import { useManagedContext } from '../../hooks';

const SortHabilitaciones = (list) => {
  return [...list].sort((a, b) => {
    const fechaA = a.fechaHabilitacion ? new Date(a.fechaHabilitacion).getTime() : null;
    const fechaB = b.fechaHabilitacion ? new Date(b.fechaHabilitacion).getTime() : null;
    if (fechaA === null && fechaB !== null) return 1;
    if (fechaA !== null && fechaB === null) return -1;
    if (fechaA !== fechaB) return fechaB - fechaA;
    return b.id - a.id;
  });
}

const HabilitacionComercioGrid = (props) => {
  const { showMessageModal } = useManagedContext();

  //#region Hooks
  const [state, setState] = useState({
      idComercio: 0,
      showForm: false,
      modeFormEdit: false,
      rowForm: null,
      list: []
  });

  const dispatch = useDispatch();
  const sequenceValue = useSelector( (state) => state.sequence.value );

  const mount = () => {
    setState(prevState => {
      const list = SortHabilitaciones(props.data.list.filter(x => x.state !== 'r'));
      return {...prevState,
        idComercio: props.data.idComercio,
        list: list };
    });
  }
  useEffect(mount, [props.data]);

  const [, getRowLista] = useLista({
    listas: ['TipoHabilitacion'],
    onLoaded: (listas, isSuccess, error) => {
      if (isSuccess) {
        setState(prevState => ({...prevState}));
      }
      else {
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
      }
    },
    memo: {
      key: 'TipoHabilitacion',
      timeout: 0
    }
  });

  const getDescTipoHabilitacion = (id) => {
    const row = getRowLista('TipoHabilitacion', id);
    return (row) ? row.nombre : '';
  }
  //#endregion

  const cellA = (data) =>    <div className='action'>
                                {!props.disabled && (
                                  <div onClick={ (event) => handleClickHabilitacionAdd() } className="link">
                                      <span className="material-symbols-outlined" title="nuevo">add</span>
                                  </div>
                                )}
                              </div>
  const cellVMR = (data) =>  <div className='action'>
                                  {!props.disabled && (
                                  <div onClick={ (event) => handleClickHabilitacionModify(data.value) } className="link">
                                      <span className="material-symbols-outlined" title="modificar">stylus</span>
                                  </div>
                                  )}
                                  {!props.disabled && (
                                  <div onClick={ (event) => handleClickHabilitacionRemove(data.value) } className="link">
                                      <span className="material-symbols-outlined" title="Eliminar">delete</span>
                                  </div>
                                  )}
                              </div>

  const tableColumns = [
    { Header: 'Tipo habilitación', Cell: (props) => getDescTipoHabilitacion(props.value), accessor: 'idTipoHabilitacion', width: '25%' },
    { Header: 'Fecha habilitación', Cell: (data) => (data.value) ? getDateToString(data.value, false) : '', accessor: 'fechaHabilitacion', width: '12%' },
    { Header: 'Fecha vencimiento', Cell: (data) => (data.value) ? getDateToString(data.value, false) : '', accessor: 'fechaVencimiento', width: '12%' },
    { Header: 'Resolución', accessor: 'resolucion', width: '21%' },
    { Header: 'Expediente', accessor: 'detalleExpediente', width: '20%' },

    { Header: cellA, Cell: cellVMR, id:'abm', accessor: 'id', width: '10%', disableGlobalFilter: true, disableSortBy: true }
  ];

  //#region Handles
  const handleClickHabilitacionAdd = () => {
    const idTemporal = (-1)*sequenceValue; //los registros temporales tienen id negativa
    setState(prevState => {
      const rowForm = {
        id: idTemporal,
        idComercio: state.idComercio,
        idTipoHabilitacion: 0,
        fechaHabilitacion: null,
        fechaVencimiento: null,
        resolucion: "",
        idExpediente: 0,
        detalleExpediente: "",
        state: 'a'
      };
      return {...prevState, showForm: true, modeFormEdit: true, rowForm: rowForm};
    });
    dispatch( sequenceActionNext() );
  }
  const handleClickHabilitacionModify = (id) => {
    setState(prevState => {
      const rowForm = state.list.find(x => x.id === id);
      return {...prevState, showForm: true, modeFormEdit: true, rowForm: rowForm};
    });
  }
  const handleClickHabilitacionRemove = (id) => {
    const habilitacion = state.list.find(x => x.id === id);
    showMessageModal({
      ...MESSAGE_MODALS.BORRAR,
      message: `¿Está seguro de borrar la habilitación ${getDescTipoHabilitacion(habilitacion.idTipoHabilitacion)}?`,
      onConfirm: () => {
        props.onChange('HabilitacionComercio', { ...habilitacion, state: 'r' })
      }
    })
  }
  //#endregion

  //funciones
  function UpdateHabilitacionComercio(row) {
    row.state = isNull(state.list.find(x => x.id === row.id)) ? 'a' : 'm';
    props.onChange('HabilitacionComercio', row);
  }

  return (
  <>

    {state.showForm &&
        <HabilitacionComercioModal
            processKey={props.processKey}
            disabled={!state.modeFormEdit}
            data={{
              entity: state.rowForm
            }}
            onDismiss={() => {
              setState(prevState => {
                  return {...prevState, showForm: false, rowForm: null};
              });
            }}
            onConfirm={(row) => {
              setState(prevState => {
                  return {...prevState, showForm: false, rowForm: null};
              });
              UpdateHabilitacionComercio(row);
            }}
        />
    }

    <TableCustom
        showFilterGlobal={false}
        className={'TableCustomBase'}
        columns={tableColumns}
        data={state.list}
    />

  </>
  );
}

HabilitacionComercioGrid.propTypes = {
  processKey: string.isRequired,
  disabled: bool,
  data: object.isRequired,
  onChange: func.isRequired
};

HabilitacionComercioGrid.defaultProps = {
  disabled: false
};

export default HabilitacionComercioGrid;
